import { createAction, props } from '@ngrx/store';

export const decrypt = createAction('[Cases] Decrypt case IDs', props<{ decrypted: boolean }>());
export const decryptCases = createAction('[Cases] Decrypt cases');
export const addDecryptedCases = createAction('[Cases] Add decrypted cases', props<{ decryptedCases: any[] }>());
export const loadCases = createAction('[Cases] Load cases', props<{ cases: any[]; currentUserId: string }>());
export const casesLoaded = createAction(
  '[Cases] Cases loaded',
  props<{ cases: any[]; decryptedCases: any[]; currentUserId: string }>()
);
export const updateDecryptedCaseData = createAction(
  '[Cases] Update current decrypted case Data',
  props<{ id: string; data: any }>()
);
export const updateCaseData = createAction(
  '[Cases] Update current case Data',
  props<{ id: string; data: any; currentUserId: string }>()
);

export const saveCase = createAction('[Cases] Save case', props<{ id: string; data: any; currentUserId: string }>());

export const casesActionError = createAction('[Cases] Processing failed', props<{ error: string }>());

export const setCurrWorkspace = createAction('[Cases] Set current workspace', props<{ id: string }>());

export const currWorkspaceLoaded = createAction(
  '[Cases] Current workspace loaded in state',
  props<{ workspace: any }>()
);

export const casesListed = createAction('[Cases] Cases listed', props<{ caseList: any[] }>());

export const setCurrentCaseId = createAction('[Cases] Set current case Id', props<{ caseId: string }>());
